import { combineReducers } from 'redux';

import contexts from './Contexto';

export default combineReducers({
    contexts 
});